import { http } from '../../core/services/http';

export const loadExcludeCustomerFromProcessingFee = () =>
  http.get(`/payment/isVendorLevelProcessingFeePassed`).then(response => response.data);
